import React, { PureComponent } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";

import { getResourceList, getPaging, setResouceType } from "../../reducers/resources.reducer";
import { INTERNAL_RESOURCE_TYPE, INVOICES_PER_PAGE, IN_PROGRESS_STATUS } from "../Invoices/constants";
import { SET_PAGE } from "../../actions";

export class ResourceList extends PureComponent {
  state = {};

  componentDidMount = () => {
    this.props.dispatch(setResouceType(this.props.resourceType));
    this.props.fetch();
  };

  static getDerivedStateFromProps(nextProps, state) {
    const { tenantSlug } = nextProps;

    if (tenantSlug && state.tenantSlug !== tenantSlug) nextProps.fetch();

    return { ...state, ...{ tenantSlug } };
  }

  handleLoadMore = nextPage => {
    this.props.fetch(nextPage);
  };

  render() {
    const { loader, paging = {}, children, list, errors, filter, resourceType } = this.props;
    const { hasMore } = paging;

    if (!isEmpty(errors)) {
      return children(list);
    }

    return (
      <InfiniteScroll pageStart={1} initialLoad={false} loadMore={this.handleLoadMore} hasMore={hasMore} loader={loader}>
        {children(list)}
      </InfiniteScroll>
    );
  }
}

const mapStateToProps = state => ({
  list: getResourceList(state) || [],
  paging: getPaging(state),
  errors: state.resources.errors
});

export default connect(mapStateToProps)(ResourceList);
